/**
 * Kollekció dizájn nézet — háttér előmelegítés hoverre (idle, nem blokkolja az oldalt).
 */
(function () {
  const API = "https://86-48-5-149.sslip.io/api/collection-styles/collection";
  const PER_GROUP = 16;
  const done = new Set();

  function warmStore() {
    return window.__thStyleLayoutWarm || (window.__thStyleLayoutWarm = {});
  }

  function handleFromHref(href) {
    try {
      const match = new URL(href, window.location.origin).pathname.match(/\/collections\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : "";
    } catch {
      return "";
    }
  }

  function warmOverview(handle) {
    if (!handle || done.has(handle)) return;
    done.add(handle);
    const key = `${handle}:overview`;
    const store = warmStore();
    if (store[key]) return;
    const url = `${API}?handle=${encodeURIComponent(handle)}&scope=overview&per_group=${PER_GROUP}`;
    store[key] = fetch(url, { mode: "cors", headers: { Accept: "application/json" } })
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null);
  }

  function scheduleIdle(fn) {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(fn, { timeout: 2500 });
    } else {
      window.setTimeout(fn, 150);
    }
  }

  document.addEventListener(
    "mouseover",
    (event) => {
      const link = event.target.closest("a[href*='/collections/']");
      if (!link) return;
      const handle = handleFromHref(link.getAttribute("href") || "");
      if (handle) scheduleIdle(() => warmOverview(handle));
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    "focusin",
    (event) => {
      const link = event.target.closest?.("a[href*='/collections/']");
      if (!link) return;
      const handle = handleFromHref(link.getAttribute("href") || "");
      if (handle) scheduleIdle(() => warmOverview(handle));
    },
    { passive: true, capture: true }
  );
})();
